import React, {Fragment} from 'react';
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputCheckbox, FormTextarea, FormInput, FormInputDatePicker } from "../../../ReactHookForm/FormComponents";

const HookSubFormReducedTimetable = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const isReducedTimetable= watch(sectionName + '.ap_pt_flag')

    return (
        <FieldsetContainer title='Reduced Timetable' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Has a reduced timetable been agreed?' sectionName={sectionName} name={'ap_pt_flag'}
                                       register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            {isReducedTimetable === true &&
                <Fragment>
                    <BootstrapRow>
                        <BootstrapCol width={6}>
                            <FormInputDatePicker readOnly={readOnly} label='Part Time Timetable Start Date' sectionName={sectionName}
                                                 name={'dmy_ap_pt_start_date'}
                                                 control={control} required={true} formErrors={formErrors}/>
                        </BootstrapCol>
                        <BootstrapCol width={6}>
                            <FormInput readOnly={readOnly} label='Number of Hours' sectionName={sectionName} name={'ap_pt_hours'} register={register} required={true}
                                       maxLength={100} formErrors={formErrors}/>
                        </BootstrapCol>
                    </BootstrapRow>

                    <BootstrapRow>
                        <BootstrapCol width={12}>
                            <FormTextarea readOnly={readOnly} label='Details / Reason' sectionName={sectionName} name={'ap_pt_reason'} register={register}
                                          required={false}
                                          maxLength={1000} formErrors={formErrors}/>
                        </BootstrapCol>
                    </BootstrapRow>

                </Fragment>
            }

        </FieldsetContainer>
    )
}


export default HookSubFormReducedTimetable;
